import { ReactNode } from 'react'
import styled from 'styled-components'
import Mono from '../../../ui/Mono/Mono'

export const NumCell = ({ children }: { children: ReactNode }) => <Num>{children}</Num>

export const QtyCell = ({ children }: { children: ReactNode }) => <Qty>{children}</Qty>

const Num = styled(Mono)`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.ink};
  letter-spacing: -0.01em;
`

const Qty = styled(Mono)`
  font-size: ${({ theme }) => theme.text.md};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.ink2};
`
